/* lua.js generated code 0.3.0 */

CacheManager = xClass("CacheManager")
var _instance = null
CacheManager.getInstance = function () {
    var self = this
    if (!_instance) {
        _instance = CacheManager.new()
    }
    return _instance
}
CacheManager.prototype.ctor = function () {
    var self = this
    self.preLoginTime = 0
    self.wakeTimeInHomeScene = null
    self.paymentTradeID = ""
    self.dc4UserDataUpdatePreTimeUsed = null
    self.bucket_publish_name = null
    self.cacheForBindingSuccess = null
    self.passLevelCacheStarData = null
    self.cacheOldScore = null
    self.cacheNewScore = null
    self.enterBackgroundTime = null
    self.dcCache4AppStoreUpdate_update_version = null
    self.homeSceneOldScoreCache = null
    self.exitMainLevelAnim = null
    self.exitMysteryLevelAnim = null
    self.lastPlayMysteryLevel = null
}
CacheManager.prototype.setPreLoginTime = function (v) {
    var self = this
    self.preLoginTime = v
}
CacheManager.prototype.getPreLoginTime = function () {
    var self = this
    return self.preLoginTime
}
CacheManager.prototype.initPaymentTradeID = function () {
    var self = this
    self.paymentTradeID = require("hecore/uuid").getUUID() || ""
}
CacheManager.prototype.getPaymentTradeID = function () {
    var self = this
    return self.paymentTradeID
}
CacheManager.prototype.cleanPaymentTradeID = function () {
    var self = this
    self.paymentTradeID = ""
}
// CacheManager.prototype.getBucketPublishName = function () {
//     var self = this
//     if (!__ANDROID) {
//         return ""
//     }
//     if (!self.bucket_publish_name) {
//         function getServer() {
//             if (he.StartupConfig.getInstance().getServer() !== "0") {
//                 self.bucket_publish_name = he.StartupConfig.getInstance().getServer()
//             }
//         }
//         function getApkSource() {
//             var MainActivityHolder = luajava.bindClass("com.happyelements.android.MainActivityHolder")
//             var ApplicationHelper = luajava.bindClass("com.happyelements.android.ApplicationHelper")
//             var context = MainActivityHolder.ACTIVITY.getContext()
//             if (ApplicationHelper.getApkSource) {
//                 var comment = ApplicationHelper.getApkSource(context)
//                 if (comment) {
//                     self.bucket_publish_name = he.HeDisplayUtil.urlEncode(comment)
//                 }
//             }
//         }
//         function getChinaMobileChannelId() {
//             var MainActivityHolder = luajava.bindClass("com.happyelements.android.MainActivityHolder")
//             var IAPPayment = luajava.bindClass("com.happyelements.android.operatorpayment.cmmm.CmmmPayment")
//             var context = MainActivityHolder.ACTIVITY.getContext()
//             if (IAPPayment.loadChannelID) {
//                 self.bucket_publish_name = IAPPayment.loadChannelID(context)
//             }
//         }
//         pcall(getServer)
//         if (!self.bucket_publish_name) {
//             pcall(getApkSource)
//         }
//         if (!self.bucket_publish_name) {
//             pcall(getChinaMobileChannelId)
//         }
//     }
//     return self.bucket_publish_name || ""
// }
CacheManager.prototype.cleanPassLevelCache = function () {
    var self = this
    self.passLevelCacheStarData = null
    self.cacheOldScore = null
    self.cacheNewScore = null
}

CacheManager.prototype.setHomeSceneOldScoreCache = function (v) {
    this.homeSceneOldScoreCache = v
}

CacheManager.prototype.getHomeSceneOldScoreCache = function () {
    return this.homeSceneOldScoreCache
}

CacheManager.prototype.cleanHomeSceneOldScoreCache = function () {
    this.homeSceneOldScoreCache = null
}

CacheManager.prototype.setExitMainLevelAnim = function (v) {
    this.exitMainLevelAnim = v
}

CacheManager.prototype.getExitMainLevelAnim = function () {
    return this.exitMainLevelAnim
}
CacheManager.prototype.cleanExitMainLevelAnim = function () {
    this.exitMainLevelAnim = null
}

CacheManager.prototype.cleanHomeSceneOldScoreCache = function () {
    this.exitMainLevelAnim = null
}

// 神秘岛
CacheManager.prototype.setExitMysteryLevelAnim = function (v) {
    this.exitMysteryLevelAnim = v
}

CacheManager.prototype.getExitMysteryLevelAnim = function () {
    return this.exitMysteryLevelAnim
}



